import React from 'react';
import {
  cssColorValue,
  screenMdMax,
  ButtonSecondary,
  screenLgMin,
  Text,
  screenXsMax,
} from '@spotify-internal/encore-web';
import { useT } from '../../../features/src/i18n';
import styled from 'styled-components';
import { VideoCategoryType, VideoType } from './types';
import { HeaderImageGrid } from '../ui/HeaderImageGrid';
import { TWO_COLUMN_MAX_WIDTH } from '@spotify-internal/frodor-modules';
import { InteractiveElement } from '../../utils/InteractiveElement';
import { TrackVisibility } from '../../utils/Visibility/TrackVisibility';

const TextContent = styled.div`
  color: ${cssColorValue('textBase')};
  grid-column: 1 / 7;
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: end;

  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    grid-column: 1 / -1;
  }

  // xs screen sizes body text hidden
  @media (max-width: ${screenXsMax}) {
    .text-body {
      display: none;
    }
  }
`;

const LargeScreenPlayButton = styled.div`
  background-image: url('data:image/svg+xml;charset=utf-8,%3Csvg%20width%3D%2272px%22%20height%3D%2272px%22%20viewBox%3D%220%200%2072%2072%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%0D%0A%20%20%20%20%3C%21--%20Generator%3A%20Sketch%2049.2%20%2851160%29%20-%20http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch%20--%3E%0D%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%0D%0A%20%20%20%20%3Cdefs%3E%0D%0A%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22path-1%22%20cx%3D%2235.6%22%20cy%3D%2235.6%22%20r%3D%2235.6%22%3E%3C%2Fcircle%3E%0D%0A%20%20%20%20%3C%2Fdefs%3E%0D%0A%20%20%20%20%3Cg%20id%3D%22Video-Pages%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0D%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Artboard-2%22%20transform%3D%22translate%28-932.000000%2C%20-651.000000%29%22%3E%0D%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22VideoHomeThumbnails-Copy-7%22%20transform%3D%22translate%28767.000000%2C%20574.000000%29%22%3E%0D%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group-3%22%3E%0D%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22PlayButton%22%20transform%3D%22translate%28165.000000%2C%2077.000000%29%22%3E%0D%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Oval%22%3E%0D%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20fill-opacity%3D%220.5%22%20fill%3D%22%23000000%22%20fill-rule%3D%22evenodd%22%20xlink%3Ahref%3D%22%23path-1%22%3E%3C%2Fuse%3E%0D%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Ccircle%20stroke%3D%22%23FFFFFF%22%20stroke-width%3D%222.8%22%20cx%3D%2235.6%22%20cy%3D%2235.6%22%20r%3D%2234.2%22%3E%3C%2Fcircle%3E%0D%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0D%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpolygon%20id%3D%22Shape%22%20fill%3D%22%23FFFFFF%22%20fill-rule%3D%22nonzero%22%20points%3D%2250.7515152%2035.3703704%2025.6%2020%2025.6%2050.7407407%22%3E%3C%2Fpolygon%3E%0D%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0D%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0D%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0D%0A%20%20%20%20%20%20%20%20%3C%2Fg%3E%0D%0A%20%20%20%20%3C%2Fg%3E%0D%0A%3C%2Fsvg%3E');
  background-size: cover;
  display: block;
  height: 70px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 70px;

  @media (max-width: ${screenMdMax}) {
    display: none;
  }
`;

const SmallScreenPlayButton = styled(ButtonSecondary)`
  border-color: ${cssColorValue('textBase')};
  @media (min-width: ${screenLgMin}) {
    display: none;
  }

  :focus {
    border-color: ${cssColorValue('textBase')};
  }
`;

type Props = {
  video: VideoType;
  videoCategory: VideoCategoryType;
};
export const VideoCategoryHeader = ({ video, videoCategory }: Props) => {
  const t = useT();
  return (
    <TrackVisibility
      threshold={0.4}
      eventCategory="Frodor - videos page header"
      eventLabel={video.name}
    >
      <HeaderImageGrid
        backgroundImage={
          video && video.largeImage && `url("${video.largeImage.url}")`
        }
        isTall
      >
        <TextContent>
          <Text
            variant="bodySmallBold"
            paddingBottom="tighter-3"
            style={{
              textTransform: 'uppercase',
            }}
          >
            {videoCategory && videoCategory.name}
          </Text>
          <Text paddingBottom="base" variant="headlineLarge">
            {video.name}
          </Text>
          <Text
            variant="bodyMedium"
            paddingBottom="looser"
            className="text-body"
          >
            {video.body}
          </Text>
          <InteractiveElement
            href={`/video/${video.urlSlug}`}
            trackingLabel="Featured Video"
            trackingCategory="Videos"
          >
            <LargeScreenPlayButton
              aria-label={t(
                'FRODOR_LEGACY_VIDEOS_WATCH_NOW_SPAN',
                'Watch now',
                'Click here to watch this video now',
              )}
            />
          </InteractiveElement>
          <div style={{ width: 'auto' }}>
            <InteractiveElement
              customComponent={SmallScreenPlayButton}
              href={`/video/${video.urlSlug}`}
              trackingLabel="Featured Video"
              trackingCategory="Videos"
            >
              {t(
                'FRODOR_LEGACY_VIDEOS_WATCH_NOW_SPAN',
                'Watch now',
                'Click here to watch this video now',
              )}
            </InteractiveElement>
          </div>
        </TextContent>
      </HeaderImageGrid>
    </TrackVisibility>
  );
};
